import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { Typography, Button, Tag } from 'antd';
import { useStore } from '../../../../store/rootStore';
import classNames from 'classnames';
import { WarningOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { isNotificationOfType, typeToColor } from '../../helpers';
import { Trans } from 'react-i18next';
import styles from './List.module.scss';
const { Text } = Typography;
const statusIconMap = {
    warning: React.createElement(WarningOutlined, { className: classNames(styles.statusIcon, styles.warning) }),
    error: React.createElement(ExclamationCircleOutlined, { className: classNames(styles.statusIcon, styles.error) }),
};
const NotificationList = ({ className, showHeader = true, showActions = true, onNotificationClick, onSeeAllClick, fullScreen = false, }) => {
    const { notificationsStore } = useStore();
    const [isUnreadOnly, setIsUnreadOnly] = useState(false);
    const filteredNotifications = isUnreadOnly
        ? notificationsStore.notifications.filter((n) => !n.read)
        : notificationsStore.notifications;
    const renderTypeSpecificTitle = (notification) => {
        if (isNotificationOfType(notification, 'channel')) {
            return (React.createElement("div", { className: styles.channelTitleContainer },
                notification.source.channel,
                " - ",
                notification.source.accountId));
        }
        return '';
    };
    return (React.createElement("div", { className: className },
        showHeader && (React.createElement("div", { className: styles.header },
            React.createElement("div", { className: styles.filter },
                React.createElement(Text, { className: classNames(styles.filterItem, { [styles.active]: !isUnreadOnly }), onClick: () => setIsUnreadOnly(false) },
                    React.createElement(Trans, { i18nKey: "all" })),
                React.createElement(Text, { className: styles.divider }, "/"),
                React.createElement(Text, { className: classNames(styles.filterItem, { [styles.active]: isUnreadOnly }), onClick: () => setIsUnreadOnly(true) },
                    React.createElement(Trans, { i18nKey: "unread" }))),
            showActions && (React.createElement(Button, { type: "link", size: "small", onClick: onSeeAllClick },
                React.createElement(Trans, { i18nKey: "seeAll" }))))),
        React.createElement("div", { className: classNames(styles.notifications, { [styles.fullScreen]: fullScreen }) }, filteredNotifications.map((notification) => (React.createElement("div", { key: notification._id, className: styles.notificationItem, onClick: () => onNotificationClick === null || onNotificationClick === void 0 ? void 0 : onNotificationClick(notification._id) },
            React.createElement("div", { className: styles.content },
                React.createElement("div", { className: styles.titleContainer },
                    React.createElement("div", { className: styles.statusWrapper },
                        React.createElement("div", { className: styles.statusIconContainer },
                            statusIconMap[notification.status],
                            React.createElement(Text, { className: classNames(styles.statusText, {
                                    [styles.warning]: notification.status === 'warning',
                                    [styles.error]: notification.status === 'error',
                                }), strong: true }, notification.status)),
                        React.createElement(Text, { strong: true }, renderTypeSpecificTitle(notification))),
                    React.createElement(Tag, { className: styles.typeTag, color: typeToColor[notification.type] }, notification.type)),
                React.createElement(Text, { type: "secondary" }, notification.description))))))));
};
export default observer(NotificationList);
